import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const SEO = ({
  title = "12 Tribes Doula Services | Holistic Birth Support for Black Mothers in Central Georgia",
  description = "Professional doula services for Black mothers in Central Georgia. Holistic birth support, herbal consultations, natural healing, and postpartum care in Macon, Warner Robins & surrounding areas.",
  keywords = "doula Central Georgia, Black doula Georgia, birth doula Macon GA, holistic birth support, natural birth Georgia, postpartum doula, herbal doula services, Warner Robins doula, culturally centered birth support",
  url = "https://georgia-birth-coach.preview.emergentagent.com",
  image = "https://images.pexels.com/photos/6393375/pexels-photo-6393375.jpeg?auto=compress&cs=tinysrgb&w=1200",
  type = "website",
  author = "12 Tribes Doula Services",
  publishedDate,
  modifiedDate,
  article = false
}) => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "12 Tribes Doula Services",
    "image": image,
    "description": description,
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Central Georgia",
      "addressRegion": "GA",
      "addressCountry": "US"
    },
    "telephone": "(678) 876-1637",
    "email": "info@12tribesdoula.com",
    "priceRange": "$$",
    "openingHours": "Mo-Su",
    "areaServed": [
      {
        "@type": "City",
        "name": "Macon"
      },
      {
        "@type": "City",
        "name": "Warner Robins"
      },
      {
        "@type": "City",
        "name": "Milledgeville"
      },
      {
        "@type": "Place",
        "name": "Central Georgia"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Doula Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Prenatal Support"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Labor Support"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Postpartum Care"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Herbal Consultations"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Tea Blends & Natural Healing"
          }
        }
      ]
    }
  };

  const articleStructuredData = article ? {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": description,
    "image": image,
    "author": {
      "@type": "Organization",
      "name": author
    },
    "publisher": {
      "@type": "Organization",
      "name": "12 Tribes Doula Services",
      "logo": {
        "@type": "ImageObject",
        "url": image
      }
    },
    "datePublished": publishedDate,
    "dateModified": modifiedDate || publishedDate
  } : null;

  return (
    <HelmetProvider>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />
        <link rel="canonical" href={url} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content={type} />
        <meta property="og:url" content={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:site_name" content="12 Tribes Doula Services" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={url} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={image} />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="language" content="English" />
        <meta name="geo.region" content="US-GA" />
        <meta name="geo.placename" content="Central Georgia" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
        {article && articleStructuredData && (
          <script type="application/ld+json">
            {JSON.stringify(articleStructuredData)}
          </script>
        )}
      </Helmet>
    </HelmetProvider>
  );
};

export default SEO;
